import { useMemo } from 'react';
import { useKeywordMap } from '@vms/RestaurantMenu';
import { useInstantCharts } from '@core/apiHooks/useInstantCharts';

export type SubCategory = ReturnType<typeof useInstantChartsData>['subCategories'][number];
export type InstantChart = SubCategory['charts'][number];

export function useInstantChartsData() {
    const { data: categories, isLoading } = useInstantCharts();
    const keywordsById = useKeywordMap();

    const subCategories = useMemo(
        () => categories.flatMap(category =>
            (category.subCategories ?? []).map(sub => ({
                ...sub,
                charts: (sub.charts ?? []).map(chart => ({
                    ...chart,
                    keywords: (chart.wordIds ?? [])
                        .map(id => keywordsById.get(id))
                        .filter(Boolean),
                })),
            })),
        ),
        [categories, keywordsById],
    );

    return { categories, isLoading, subCategories };
}
